<template>
  <div class="viz">
    <Menu background="gradient" />
    <template v-if="!isDatasetLoading && !areAuthorsLoading && hierarchyData">
      <VizNavigator v-if="$tvaMq === 'desktop'" :isGallery="showGallery" />
      <template v-if="!showGallery">
        <!-- Viz -->
        <template v-if="$tvaMq === 'desktop'">
          <VizFilter @showInfo="toggleInfo" />
          <VizTooltip />
          <InfoModal @closeModal="showInfo = false" v-if="showInfo"/>
        </template>
        <template v-else>
          <VizFilterMobile />
        </template>
        <VizComponent />
      </template>
      <template v-if="showGallery">
        <!-- <Gallery/> -->
        <VizGallery
          v-if="$tvaMq === 'desktop'"
          :metadata="getVizElSelected.data"
          :isGalleryOpen="showGallery"
        />
        <VizGalleryTouch
          v-if="$tvaMq !== 'desktop'"
          :metadata="getVizElSelected.data"
          :isGalleryOpen="showGallery"
        />
      </template>
    </template>
    <div v-else>
      <Loader class="loader" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Menu from "@/components/Menu";
import VizComponent from "@/components/main-viz/VizComponent";
import VizNavigator from "@/components/main-viz/VizNavigator";
import VizGallery from "@/components/main-viz/VizGallery";
import VizGalleryTouch from "@/components/main-viz/VizGalleryTouch";
import VizFilter from "@/components/main-viz/VizFilter";
import VizFilterMobile from "@/components/main-viz/VizFilterMobile";
import VizTooltip from "@/components/main-viz/VizTooltip";
import InfoModal from "@/components/main-viz/InfoModal";
import Loader from "@/components/Loader.vue";
import queryListener from "@/mixins/queryListener";
export default {
  mixins: [queryListener],
  created() {
    // setdataset in base a lingua?
    this.setDataset(this.$ml.current);
    this.setAuthors(this.$ml.current);
  },
  data() {
    return {
      showInfo: false
    };
  },
  methods: {
    toggleInfo() {
      return (this.showInfo = !this.showInfo);
    },
    ...mapActions(["setDataset", "setAuthors"])
  },
  computed: {
    showGallery() {
      return this.getVizElSelected && this.getVizElSelected.depth === 4;
    },
    ...mapGetters(["isDatasetLoading", "getVizElSelected", "areAuthorsLoading"])
  },
  components: {
    VizComponent,
    VizNavigator,
    VizGallery,
    VizFilter,
    VizGalleryTouch,
    Menu,
    VizTooltip,
    Loader,
    VizFilterMobile,
    InfoModal
  }
};
</script>
<style lang="scss" scoped>
.viz {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
    180deg,
    #96c2c4 -3.84%,
    #bea95e 49.07%,
    #573c46 106.58%
  );
  .mobile &,
  .tablet & {
    display: initial;
  }
}
</style>
